import CaseStudyLarge from './CaseStudyLarge'

export default CaseStudyLarge
